import React, {Component, Fragment} from 'react';
import ItemContainer from 'items/ItemContainer';
import {Button, ButtonGroup, Col, FormGroup} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import {connect} from 'react-redux';
import * as items from 'items/actions/items';
import {CLASS_CHOICES, TAX_CHOICES, TYPE_CHOICES} from 'items/Item';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import DeleteItem from 'items/DeleteItem';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import Date from 'apa/components/Date';
import {FormattedNumber} from 'react-intl';
import {getURL} from 'apa/actions/generic'

@connect(
    state => ({
        auth: state.apa,
        items: state.items
    }),
    null
)
class CarryDisplay extends Component {
    render() {
        const {currentType, currentMonth} = this.props.items;
        const {itemList} = this.props.items;
        let carry = 0;
        for (var item of itemList) {
            if (item.class_type == 2 || item.class_type == 3 || item.class_type == 4)
                carry += Number(item.amount);
            if (item.class_type == 1)
                carry -= Number(item.amount);
        }
        if (currentType === 1 && currentMonth > 0) {
            return (
                <Button color='default'>Übertrag: {Money(carry)}</Button>
            )
        } else {
            return (
                <Button color='default'>Summe: {Money(this.props.sum || carry)}</Button>
            )
        }
    }
}

export function dateCell(cell) {
    return (
        <Date date={cell}/>
    )
}

function invoiceLink(cell, row) {
    return (
        cell ? <span>
            <NavLink to={`/invoices/${cell.id}`}>{cell.rechnungsnummer}</NavLink>
    <p>{row.customer}</p>
            </span> : <span> </span>
    )
}

function invoiceActions(cell, row) {
    return (
        <ButtonGroup key={`options_${row.id}`}>
            <NavLink to={`/items/${row.id}/edit`} className='btn btn-primary'>
                <i className='fa fa-edit'> </i>
            </NavLink>
            <DeleteItem item={row}/>
        </ButtonGroup>
    )
}

const {SearchBar, ClearSearchButton} = Search;
export const Money = (value) => <FormattedNumber value={value || 0} style={'currency'} currency={'EUR'}/>;
const itemColumns = [
    {
        text: 'Datum',
        sort: true,
        dataField: 'date',
        formatter: cell => dateCell(cell)
    },
    {
        text: 'Rechnung',
        sort: true,
        dataField: 'rechnung',
        formatter: (cell, row) => invoiceLink(cell, row)
    },
    {
        text: 'Beschreibung',
        sort: true,
        dataField: 'description'
    },
    {
        text: 'Betrag',
        sort: true,
        dataField: 'amount',
        align: 'right',
        formatter: cell => Money(cell)
    },
    {
        text: 'MwSt.',
        sort: true,
        dataField: 'tax_type',
        formatter: cell => TAX_CHOICES[cell]
    },
    {
        text: 'Art',
        sort: true,
        dataField: 'type',
        formatter: cell => TYPE_CHOICES[cell]
    },
    {
        text: 'Typ',
        sort: true,
        dataField: 'class_type',
        formatter: cell => CLASS_CHOICES[cell]
    },
    {
        text: '',
        dataField: 'actions',
        sort: false,
        isDummyField: true,
        formatter: (cell, row) => invoiceActions(cell, row)
    },
];

@connect(
    state => {
        return {
            items: state.items,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchItems: () => dispatch(items.fetchItemList()),
            add: item => dispatch(items.add(item))
        }
    }
)
export default class ItemList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isDownloading: false,
            sum: 0
        }
    }

    componentDidMount() {
        this.props.fetchItems()
    }

    @autobind
    downloadExcel() {
        if (this.state.isDownloading)
            return;
        this.setState({
            isDownloading: true
        })
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`
        };
        const items = this.props.items;
        const data = {
            year: items.currentYear,
            month: items.currentMonth,
            quarter: items.currentQuarter,
            type: items.currentType
        };
        fetch(
            getURL('/api/items/export/', data),
            {headers}
        )
            .then(
                response => response.blob()
            )
            .then(
                blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'Export.docx';
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove();  //afterwards we remove the element again
                    this.setState({
                        isDownloading: false
                    })
                }
            )
    }

    @autobind
    handleDataChange() {
        const itemList = this.table.searchContext.getSearched()
        let sum = 0;
        for (var item of itemList) {
            if (item.class_type == 2 || item.class_type == 3 || item.class_type == 4)
                sum += Number(item.amount);
            if (item.class_type == 1)
                sum -= Number(item.amount);
        }
        this.setState({sum: sum})
    }

    render() {
        const {
            itemListLoading,
            itemList,
            itemListHasErrors,
            newItem,
            updatedItem
        } = this.props.items;
        if (itemListLoading) {
            return <Loading/>
        } else {
            if (itemListHasErrors) {
                return <h1>Error</h1>
            } else {
                const rowClasses = (row) => {
                    if (!!newItem && row.id === newItem.id) {
                        return 'new-row'
                    }
                    if (!!updatedItem && row.id === updatedItem.id) {
                        return 'new-row'
                    }
                    return ''
                }
                return (
                    <ItemContainer>
                        <ToolkitProvider
                            keyField='id'
                            data={itemList}
                            columns={itemColumns}
                            bootstrap4
                            search
                        >
                            {
                                props => {
                                    return <Fragment>
                                        <FormGroup row>
                                            <Col sm={4}>
                                                <SearchBar {...props.searchProps} placeholder='Suche'
                                                           onSearch={searchText => {
                                                               props.searchProps.onSearch(searchText);
                                                               this.handleDataChange(searchText)
                                                           }}/>
                                                <ClearSearchButton className="btn-secondary"
                                                                   text='Zurücksetzen' {...props.searchProps} />
                                            </Col>
                                            <Col sm={4}>
                                                <NavLink to='/items/new' className='btn btn-primary'>
                                                    Neuen Posten hinzufügen
                                                </NavLink>
                                                <Button color={'primary'} onClick={this.downloadExcel}
                                                        disabled={this.state.isDownloading}>
                                                    {this.state.isDownloading &&
                                                    <i className='fa fa-spinner fa-spin'> </i>
                                                    }
                                                    Excel
                                                </Button>
                                            </Col>
                                            <Col sm={2}>
                                                <CarryDisplay sum={this.state.sum}/>
                                            </Col>
                                        </FormGroup>
                                        <BootstrapTable

                                            rowClasses={rowClasses}
                                            pagination={paginationFactory()}
                                            striped
                                            {...props.baseProps}
                                            ref={n => this.table = n}

                                        />
                                    </Fragment>
                                }
                            }
                        </ToolkitProvider>
                    </ItemContainer>
                )
            }
        }
    }


}
